var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { C } from '#integrations';
import styles from './THead.module.css';
export const THead = ({ children, className }) => {
    return _jsx("thead", { className: C(styles.Container, className), children: children });
};
_react_refresh_temp_1 = THead;
$RefreshReg$(_react_refresh_temp_1, "THead");
